import React from "react";
import { Radar, Clock, HeartPulse, Handshake } from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "supreme", label: "Supreme Ops", icon: Radar },
    { id: "zaman-asimi", label: "Zaman Aşımı", icon: Clock },
    { id: "saglik", label: "Dosya Sağlığı", icon: HeartPulse },
    { id: "pazarlik", label: "Pazarlık", icon: Handshake },
];

export default function DosyaOperasyonMerkezLayout() {
    return (
        <MerkezHubShell
            title="Dosya Operasyon Merkezi"
            subtitle="Komuta, zaman aşımı, sağlık skoru ve pazarlık stratejisi — tek operasyon panosu."
            badge="Operasyon · Komuta"
            basePath="/yeni/dosya-operasyon-merkezi"
            tabs={TABS}
        />
    );
}
